import React from "react";
import { Paper, Stack, Typography, Box, Skeleton } from "@mui/material";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";

import InfoButton from "../Clinical/InfoButton";
import CMStatCards from "../CareManager/CMStatCards";
import BHERTable from "./BHERTable";

/**
 * Panel 4: BH Inpatient & ER Utilization.
 * 3 stat cards + BH ER frequent flyers table.
 */
export default function PanelBHER({ data, loading, onCreateTask, helpContent }) {
  if (loading) {
    return (
      <Paper elevation={0} sx={{ p: 2.5, borderRadius: 3, border: "1px solid", borderColor: "divider" }}>
        <Skeleton variant="rectangular" animation="wave" height={300} sx={{ borderRadius: 2 }} />
      </Paper>
    );
  }

  const patients = data?.patients || [];
  const hasPatients = patients.length > 0;

  const statItems = [
    { label: "BH ER Patients", value: data?.bhERPatients, color: "#D97706", bgColor: "#FEF3C7" },
    { label: "BH ER Frequent (2+)", value: data?.bhERFrequent2Plus, color: "#DC2626", bgColor: "#FEE2E2" },
    { label: "BH Inpatient", value: data?.bhInpatientCurrent, color: "#DC2626", bgColor: "#FEE2E2" },
  ];

  return (
    <Paper elevation={0} sx={{ p: 2.5, borderRadius: 3, border: "1px solid", borderColor: "divider" }}>
      <Stack spacing={2}>
        {/* Header */}
        <Stack direction="row" alignItems="center" spacing={1}>
          <Box
            sx={{
              display: "flex", alignItems: "center", justifyContent: "center",
              width: 28, height: 28, borderRadius: 1.5,
              bgcolor: "#FEE2E2", color: "#DC2626",
            }}
          >
            <LocalHospitalIcon sx={{ fontSize: 16 }} />
          </Box>
          <Box>
            <Typography variant="subtitle2" fontWeight={700}>BH Inpatient &amp; ER Utilization</Typography>
            <Typography variant="caption" color="text.secondary">BH-related hospital and emergency events</Typography>
          </Box>
          <InfoButton helpContent={helpContent} />
        </Stack>

        {/* Stat Cards */}
        <CMStatCards items={statItems} />

        {/* Table */}
        {hasPatients ? (
          <BHERTable patients={patients} onCreateTask={onCreateTask} />
        ) : (
          <Typography variant="body2" color="text.secondary" sx={{ fontStyle: "italic", textAlign: "center", py: 4 }}>
            No BH ER patients
          </Typography>
        )}
      </Stack>
    </Paper>
  );
}
